import { createContext } from 'react';
import { ViewModel } from '@steelbuy/ts-shared';

import { CreateEntityDataProviderValue, defaultCreateEntityDataValue } from './CreateEntityDataProviderValue';

export const createCreateEntityDataContext = <Model extends ViewModel>(): React.Context<
    CreateEntityDataProviderValue<Model>
> => createContext<CreateEntityDataProviderValue<Model>>(defaultCreateEntityDataValue);
